module.exports = __webpack_public_path__ + "media/feature-icons/animation-6-b3c72478.gif";